import * as React from 'react';

export default (props) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      fill={props.color || '#6C7280'}
      d="M12.162 1.349a3.882 3.882 0 1 1 5.489 5.49l-9.92 9.843a1.172 1.172 0 0 1-.452.28l-4.066 1.355c-1.563.52-3.05-.967-2.53-2.53L2.04 11.72l.05-.124c.056-.122.134-.233.229-.33l9.844-9.918ZM3.874 12.537 2.581 16.42l3.88-1.295 7.654-7.594-2.646-2.646-7.595 7.653Zm12.373-9.784a1.882 1.882 0 0 0-2.666.005l-.703.707 2.656 2.655.708-.7c.74-.735.741-1.93.005-2.667Z"
    />
  </svg>
);
